import { render, staticRenderFns } from "./customer-risk-assessment.vue?vue&type=template&id=32b02a8f&scoped=true"
import script from "./customer-risk-assessment.vue?vue&type=script&lang=js"
export * from "./customer-risk-assessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b02a8f",
  null
  
)

export default component.exports